
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults");
import { company } from '@components/config/company/Details';
import { NextSeo } from 'next-seo';
import { JsonLdFaq } from '@components/config/strucureData/FaqJsonLd';
import Services from '@pages/services';
import { JsonLdReview } from '@components/config/strucureData/ReviewsJsonLd';

export default function Index() {
  return (
    <>
      <NextSeo
        title={`Services | ${company.name}`}
        description="Providing prompt and reliable transport services tailored to your needs. Specialising in wheelchair accessible vehicles, airport transfers, and courier & small parcel service. Contact us for a seamless experience."
        openGraph={{
          url: `${company.url}/services`,
        }}
        canonical={`${company.url}/services`}
      />
      <JsonLdFaq />
      <JsonLdReview />
      <div>
        <Services />
      </div>
    </>
  );
}
